import { isDevMode, Provider } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { TranslationConfig } from '../models/config';
import { TranslateService } from '../services/translate.service';
import { TranslocoHttpLoader } from '../transloco/transloco-loader';
import { TranslocoService } from '../transloco/transloco.service';
import { TRANSLATION_CONFIG } from './translation-tokens';

export function provideTranslation(config?: Partial<TranslationConfig>): Provider[] {
  const defaultConfig: TranslationConfig = {
    availableLangs: ['en', 'de', 'es', 'es-MX', 'fr', 'pt', 'it', 'ru', 'cs', 'sk', 'ar'],
    defaultLang: 'de',
    fallbackLang: 'en',
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    missingHandler: {
      logMissingKey: false,
      useFallbackTranslation: true,
      // Keys deliberately set to "" (e.g. fac3less login.footer) must render
      // empty — without this Transloco falls back to the literal key path.
      allowEmpty: true,
    },
    failedRetries: 2,
  };

  const translocoConfig = {
    ...defaultConfig,
    ...config,
    fallbackLang: config?.fallbackLang ?? (config?.availableLangs?.[0] ?? defaultConfig.availableLangs[0]),
    missingHandler: {
      ...defaultConfig.missingHandler,
      ...config?.missingHandler,
    },
  };

  return [
    provideTransloco({
      config: translocoConfig,
      loader: TranslocoHttpLoader,
      // loader: {
      //   provide: TranslocoLoader,
      //   useFactory: (http: HttpClient) => new TranslocoHttpLoader(http, translocoConfig),
      //   deps: [HttpClient],
      // },
    }),
    
    {
      provide: TRANSLATION_CONFIG,
      useValue: translocoConfig,
    },
    {
      provide: TranslateService,
      useClass: TranslocoService,
    },
  ];
}